module.exports = __webpack_public_path__ + "static/media/market_imperfection.8b0699ae.pdf";